import type { FC } from "react";

import classnames from "classnames";

import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./ProductDetailsCtaMobileProductData.module.scss";

type ProductDetailsCtaMobileProductDataProps = {
  productName: string;
  showPricePerMonthLabel?: boolean;
  productPrice?: string | React.ReactNode | null | undefined;
};

export const ProductDetailsCtaMobileProductData: FC<ProductDetailsCtaMobileProductDataProps> = ({
  productName,
  productPrice,
  showPricePerMonthLabel,
}) => {
  const { __ } = useTranslations();

  return (
    <>
      <p className={classnames(["typography", "typography--primary", styles.productName])}>{productName}</p>
      <p className={styles.productPrice} data-price>
        {productPrice}
        {showPricePerMonthLabel && <span>{"/" + __("product.info.monthlyPriceLabel")}</span>}
      </p>
    </>
  );
};
